import React from "react";
import Arrow from "../../../assets/images/custom_documentation/Arrow.svg";
import ZoomIn from "../../../assets/images/custom_documentation/Zoom In.svg";
import ZoomOut from "../../../assets/images/custom_documentation/Zoom Out.svg";
import "./style.scss";

const StickyMenu = ({
  enhancedMenuArray,
  activeMenuIndex,
  activeSubMenuIndex,
  dropdownVisible,
  pageNumber,
  numPages,
  scale,
  handleMenuClick,
  setPageNumber,
  handleZoomIn,
  handleZoomOut,
  viewMode = false,
}) => {
  const handleSubMenuLabelClick = (e) => {
    e.stopPropagation();
  };
  return (
    <div className="sticky-menu">
      {!viewMode && (
        <ul className="menu-list">
          {enhancedMenuArray.map((item, index) => (
            <li
              key={index}
              className={`menu-item${item.child ? " has-sub-menu" : ""}${activeMenuIndex === index ? " active" : ""}`}
              onClick={() => handleMenuClick(index)}
            >
              <img src={item.icon} alt={item.name} />
              <span className="menu-label">{item.label}</span>
              {item.child && (
                <ul
                  className={`sub-menu-dropdown${dropdownVisible && activeMenuIndex === index ? " show" : ""}`}
                >
                  <p className="sub-menu-label" onClick={handleSubMenuLabelClick}>{item.label}</p>
                  {item.child.map((childItem, childIndex) => (
                    <li
                      key={`${index}-${childIndex}`}
                      onClick={(e) => handleMenuClick(index, childIndex, e)}
                      className={`sub-menu-item${activeSubMenuIndex === childIndex ? " active" : ""}`}
                    >
                      <img src={childItem.icon} alt={childItem.name} />
                      <span>{childItem.label}</span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
      <div className="page-number">
        <p>Page</p>
        {numPages <= 1 ? (
          <div className="pdf-number">
            <span className="start">{pageNumber}</span>
          </div>
        ) : (
          <>
            <p
              className={`arrow arrow-up menu-item${pageNumber <= 1 ? " disabled" : ""}`}
              onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}
            >
              <img src={Arrow} alt="arrow-up" />
              <span className="menu-label">Previous Page</span>
            </p>
            <div className="pdf-number">
              <span className="start">{pageNumber}</span>
              {numPages > 1 && <span className="end">/ {numPages}</span>}
            </div>
            <p
              className={`arrow arrow-down menu-item${pageNumber >= (numPages || 1) ? " disabled" : ""}`}
              onClick={() =>
                pageNumber < (numPages || 1) && setPageNumber(pageNumber + 1)
              }
            >
              <img src={Arrow} alt="arrow-down" />
              <span className="menu-label">Next Page</span>
            </p>
          </>
        )}
      </div>
      <div className="zoom-number">
        <p
          className={`zoom zoom-in menu-item${scale >= 1.6 ? " disabled" : ""}`}
          onClick={handleZoomIn}
        >
          <img src={ZoomIn} alt="zoom-in" />
          <span className="menu-label">Zoom In</span>
        </p>
        <p className="zoom-percent">
          {Math.round(scale * 100)}
          <span>%</span>
        </p>
        <p
          className={`zoom zoom-out menu-item${scale <= 0.6 ? " disabled" : ""}`}
          onClick={handleZoomOut}
        >
          <img src={ZoomOut} alt="zoom-out" />
          <span className="menu-label">Zoom Out</span>
        </p>
      </div>
    </div>
  );
};

export default StickyMenu;
